import './src/vaadin-side-nav.js';
export * from './src/vaadin-side-nav.js';
